<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="12" md="7" lg="9">
            <h3 tabindex="0">Gerenciar Transmissões</h3>
          </b-col>
          <b-col sm="12" md="5" lg="3">
            <b-button @click="navigate('/sala/cadastrar')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Nova Transmissão</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="12" md="12" lg="6">
            <b-form-group label="Titulo da Transmissão:">
              <b-form-input type="text" id="name" v-model="filtros.filter"
                placeholder="Titulo da Transmissão"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" @click="pesquisar">
              <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
            </b-button>
          </b-col>
          <b-col v-if="!loading" sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" @click="exportar">
              <i class="fa fa-file"></i>&nbsp;&nbsp;<span>Exportar</span>
            </b-button>
          </b-col>
          <b-col v-if="loading" sm="12" md="4" lg="3">
            <b-button block variant="primary" :disabled="true">
              <b-spinner small type="grow"></b-spinner>Exportando...</b-button>
            </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col" tabindex="0">Data da Transmissão</th>
                    <th scope="col" tabindex="0">Título da Transmissão</th>
                    <th scope="col" tabindex="0">Ações</th>
                  </tr>
                </thead>

                <tbody v-if="salas.data !== undefined">
                  <tr class="action" v-for="sala in salas.data" :key="sala.id">
                    <td tabindex="0">{{ sala.data_hora }}</td>
                    <td tabindex="0">{{ sala.titulo }}</td>
                    <td style="width: 15%">
                      <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Editar"
                        @click="editarSala(sala.id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </b-button>

                      <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Visualizar"
                        @click="visualizarSala(sala.id)">
                        <i class="fa fa-search"></i>
                      </b-button>

                      <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Deletar"
                        @click="excluirSala(sala.id)">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="4" tabindex="0">Nenhuma sala cadastrada</td>
                  </tr>
                </tbody>
              </table>
              <pagination tabindex="0" v-show="salas.data !== undefined" :totalPorPagina="totalPorPagina"
                :resource="resource"></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
      <b-card-footer>
        <b-row>
          <b-col sm="12" md="5" lg="4" xl="3" offset-md="7" offset-lg="8" offset-xl="9">
            <b-button block variant="primary" @click="navigate('sala/consulta')">
              <i class="fa fa-tv"></i>&nbsp;&nbsp;<span>Visualizar Transmissão</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
  },
  data() {
    return {
      totalPorPagina: 10,
      resource: 'salaTransmissao',
      loading: false,
      filtros: {
        filter: '',
        conferencia_id: SessionStorage.get('conferencia_atual_id')
      }
    }
  },
  computed: {
    salas() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    inputState() {
      if (!this.selectedValue) {
        return {
          type: 'is-danger',
          message: 'Data do cadastro'
        }
      }
      return {
        type: 'is-primary',
        message: ''
      }
    }
  },
  methods: {
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar() {
      this.$store.dispatch('getRegistrosSearch', { resource: 'salaTransmissao', limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    editarSala(id) {
      this.$router.push('/sala/editar/' + id)
    },
    visualizarSala(id) {
      this.$router.push('/sala/visualizar/' + id)
    },
    excluirSala(id) {
      this.$bvModal.msgBoxConfirm('Deseja excluir a sala selecionada?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/salaTransmissao/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    exportar() {
      this.loading = true
      const d = new Date();

      Vue.http.post('api/salaTransmissao/exportar', { filtros: this.filtros }, { responseType: 'blob' }).then(response => {
        if (response.ok) {
          let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)

          let time = d.getTime();
          link.download = 'Trasmissoes' + time + '.xlsx'
          link.click()
        }
        this.loading = false
      })
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/salas/Sala.vue